module.exports = __webpack_public_path__ + "static/media/notify_icon.b508ad9c.svg";